export const insuranceCompanies = [
    { value: 'Bta', label: 'BTA' },
    { value: 'Compensa', label: 'Compensa Life' },
    { value: 'Ergo', label: 'ERGO' },
    { value: 'Gjensidige', label: 'Gjensidige' },
    { value: 'If', label: 'IF draudimas' },
    { value: 'Ld', label: 'Lietuvos draudimas' },
    { value: 'Seesam', label: 'Seesam' },
  ];